import { ApolloClient, ApolloQueryResult } from '@apollo/client';
import {
    IsEmailOccupiedQuery,
    IsExpenseInternalCodeOccupiedQuery,
    IsOrderQuotationCodeOccupiedQuery,
    IsOrderRequestCodeOccupiedQuery,
    IsOrderSaleCodeOccupiedQuery,
    OrderRequestProductInputQuery,
    OrderRequestProductInputQueryVariables,
    QueryIsEmailOccupiedArgs,
    QueryIsExpenseInternalCodeOccupiedArgs,
    QueryIsOrderQuotationCodeOccupiedArgs,
    QueryIsOrderRequestCodeOccupiedArgs,
    QueryIsOrderSaleCodeOccupiedArgs,
    refetchIsEmailOccupiedQuery,
    refetchIsExpenseInternalCodeOccupiedQuery,
    refetchIsOrderQuotationCodeOccupiedQuery,
    refetchIsOrderRequestCodeOccupiedQuery,
    refetchIsOrderSaleCodeOccupiedQuery,
    refetchOrderRequestProductInputQuery,
} from './inopack-graphql-schema';

type QueryDerivativeIsOrderCodeOccupiedType = (
    client: ApolloClient<object>,
    variables: QueryIsOrderRequestCodeOccupiedArgs,
) => Promise<ApolloQueryResult<IsOrderRequestCodeOccupiedQuery>>;

export const queryIsOrderRequestCodeOccupied: QueryDerivativeIsOrderCodeOccupiedType =
    async (client, variables) => {
        return client.query(refetchIsOrderRequestCodeOccupiedQuery(variables));
    };

type QueryDerivativeIsOrderQuotationCodeOccupiedType = (
    client: ApolloClient<object>,
    variables: QueryIsOrderQuotationCodeOccupiedArgs,
) => Promise<ApolloQueryResult<IsOrderQuotationCodeOccupiedQuery>>;

export const queryIsOrderQuotationCodeOccupied: QueryDerivativeIsOrderQuotationCodeOccupiedType =
    async (client, variables) => {
        return client.query({
            ...refetchIsOrderQuotationCodeOccupiedQuery(variables),
            // Folio availability is mutable server state. Never reuse an
            // earlier cached "available" result during client validation.
            fetchPolicy: 'network-only',
        });
    };

type QueryDerivativeIsOrderSaleCodeOccupiedType = (
    client: ApolloClient<object>,
    variables: QueryIsOrderSaleCodeOccupiedArgs,
) => Promise<ApolloQueryResult<IsOrderSaleCodeOccupiedQuery>>;

export const queryIsOrderSaleCodeOccupied: QueryDerivativeIsOrderSaleCodeOccupiedType =
    async (client, variables) => {
        return client.query(refetchIsOrderSaleCodeOccupiedQuery(variables));
    };

type QueryDerivativeIsExpenseInternalCodeOccupiedType = (
    client: ApolloClient<object>,
    variables: QueryIsExpenseInternalCodeOccupiedArgs,
) => Promise<ApolloQueryResult<IsExpenseInternalCodeOccupiedQuery>>;

export const queryIsExpenseInternalCodeOccupied: QueryDerivativeIsExpenseInternalCodeOccupiedType =
    async (client, variables) => {
        return client.query(
            refetchIsExpenseInternalCodeOccupiedQuery(variables),
        );
    };

type QueryDerivativeIsEmailOccupiedType = (
    client: ApolloClient<object>,
    variables: QueryIsEmailOccupiedArgs,
) => Promise<ApolloQueryResult<IsEmailOccupiedQuery>>;

export const queryIsEmailOccupied: QueryDerivativeIsEmailOccupiedType = async (
    client,
    variables,
) => {
    return client.query(refetchIsEmailOccupiedQuery(variables));
};

type QueryDerivativeOrderRequestProductInputType = (
    client: ApolloClient<object>,
    variables: OrderRequestProductInputQueryVariables,
) => Promise<ApolloQueryResult<OrderRequestProductInputQuery>>;

export const queryOrderRequestProductInput: QueryDerivativeOrderRequestProductInputType =
    async (client, variables) => {
        return client.query(refetchOrderRequestProductInputQuery(variables));
    };
